import script from "./HierarchyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HierarchyTable.vue?vue&type=script&setup=true&lang=js"

import "./HierarchyTable.vue?vue&type=style&index=0&id=c619efbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c619efbc"]])

export default __exports__